module.exports = "/images/Contract_1.svg?efbe0b2fea2b88ef9d6ee9dffae95798";